import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { UserFamilyMember } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getFamilyMembers = http.get<object, object, UserFamilyMember[]>(
  apiBaseUrl + '/memberships/:membershipid/familyMembers',
  async () => {
    const familyMembers = await (await fetch('./data/membership/familyMembers.json')).json()
    return new HttpResponse(JSON.stringify(familyMembers), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
)
